import React, { useState } from "react";
import { NavLink } from "react-router-dom";
import "./DashboardSidebar.css";

// Icons (you can replace these with actual icons like from FontAwesome)
const icons = {
  dashboard: "🏠",
  submitTitle: "📝",
  history: "📜",
  guidelines: "📖",
  statistics: "📊",
};

const DashboardSidebar = () => {
  const [isOpen, setIsOpen] = useState(true);

  const menuItems = [
    { name: "Dashboard", path: "/", icon: icons.dashboard },
    { name: "Submit Title", path: "/submit-title", icon: icons.submitTitle },
    { name: "History", path: "/history", icon: icons.history },
    { name: "Guidelines", path: "/guidelines", icon: icons.guidelines },
    { name: "Statistics", path: "/statistics", icon: icons.statistics },
  ];

  return (
    <div className={`sidebar ${isOpen ? "open" : "collapsed"}`}>
      {/* Toggle Button */}
      <button className="toggle-btn" onClick={() => setIsOpen(!isOpen)}>
        {isOpen ? "←" : "→"}
      </button>

      {/* Menu Items */}
      <ul className="menu">
        {menuItems.map((item) => (
          <li key={item.name}>
            <NavLink
              to={item.path}
              className={({ isActive }) =>
                `menu-item ${isActive ? "active" : ""}`
              }
            >
              <span className="icon">{item.icon}</span>
              {isOpen && <span className="label">{item.name}</span>}
            </NavLink>
          </li>
        ))}
      </ul>
    </div>
  );
};

export default DashboardSidebar;
